import React, { Component } from 'react';

export default class ExampleWrapperSeamless extends Component {
  render() {
    const className = "example-card-seamless mb-4-spacing " + this.props.className; 
    return (
      <div className={className}>
        <h5 className="display-5 mb-4 font-weight-bold">
          {this.props.sectionHeading}
        </h5>
        <div>{this.props.children}</div>
      </div>
    );
  }
}
